import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MakeValidator, MakeProvider, AbstractCustomControl } from '../abstract-custom-control';
import { List } from 'immutable';
import { GridColumnData } from './grid-column-data';

@Component({
    selector: 'yt-fw-grid-with-editing',
    templateUrl: './editable-grid.component.html',
    providers: [MakeProvider(GridWithEditingComponent), MakeValidator(GridWithEditingComponent)]
})
export class GridWithEditingComponent extends AbstractCustomControl<number> implements OnInit {

    constructor(
        private translateService: TranslateService,
        protected activeModal: NgbActiveModal,
        protected changeDetectorRef: ChangeDetectorRef
    ) {
        super(changeDetectorRef);
    }

    Items: List<any>;
    @Input('Items') set SetItems(items: List<any>) {
        this.Items = items;
    }
    @Input() GridTableColumns: GridColumnData[];


    ngOnInit() {

    }

    Close() {
        this.activeModal.dismiss();
    }

    Save() {

        this.activeModal.close(true);
    }

} 